// eslint-disable-next-line no-unused-vars -- Used in JSDoc
import { Category } from '../../domain/category/entities/Category';

export default class ListCategories {
  /**
   * @param {import('../../../domain/categories/repositories/CategoryRepository').CategoryRepository} categoryRepository 
   */
  constructor(categoryRepository) {
    this.categoryRepository = categoryRepository;
  }

  /**
   * @returns {Promise<Array<Category>>}
   */
  async execute() {
    return this.categoryRepository.getAll();
  }
} 